module.exports = __webpack_public_path__ + "img/new2-img2.f5ec3f4d.png";